import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ApplicationPage = lazy(() => import('../pages/application/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/application',
    element: <ApplicationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
